export const HELP_CENTER = 'https://support.hudl.com/s/topic/0TOVY000000BO8g4AG/hudl-statsbomb?language=en_US';
export const CONTACT_SUPPORT = 'https://support.hudl.com/s/contactsupport?Category=m0HVY000002iydd';
